import Cookies from 'js-cookie';
import { ZillowHomeLoansURL } from 'src/utils/ZillowHomeLoansURL';

export const REDIRECT_LOCATION_COOKIE_NAME = 'zhl-mortgage-application-center-web.auth.redirectLocation';
/**
 * Stores the redirect location to a cookie which will be used by the login page to return the user to their requested
 * resource after a successful login.
 * @param location the location to redirect back to after login
 */
export const setRedirectLocation = (location: string) => {
    const resolvedLocationForEnvironment = new ZillowHomeLoansURL(location).resolvedURL;
    Cookies.set(REDIRECT_LOCATION_COOKIE_NAME, resolvedLocationForEnvironment, {
        path: '/homeloans',
        sameSite: 'Lax',
    });
};
